import { createContext } from "react";

const UtilsContext = createContext();

export default UtilsContext;